/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_AvatarInputs */

const en_settings_profile_avatar = /** @type {(inputs: Settings_Profile_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar`)
};

const zh_settings_profile_avatar = /** @type {(inputs: Settings_Profile_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`头像`)
};

/**
* | output |
* | --- |
* | "Avatar" |
*
* @param {Settings_Profile_AvatarInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_profile_avatar = /** @type {((inputs?: Settings_Profile_AvatarInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_AvatarInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_avatar(inputs)
	return zh_settings_profile_avatar(inputs)
});
export { settings_profile_avatar as "settings.profile.avatar" }